export interface UploadLimitDetails {
  failureReason?: string;
  currentUsageBytes?: number;
  currentUsageMB?: number;
  limitBytes?: number;
  limitMB?: number;
  remainingBytes?: number;
  remainingMB?: number;
  percentageUsed?: number;
  requestedBytes?: number;
  windowDays?: number;
}

export class UploadLimitError extends Error {
  public readonly errorCode: string;
  public readonly details: UploadLimitDetails;

  constructor(errorCode: string, message: string, details: UploadLimitDetails = {}) {
    super(message);
    this.name = 'UploadLimitError';
    this.errorCode = errorCode;
    this.details = details;
  }
}
